import axios from 'axios';

// Last-known session kind, so routes can decide synchronously (no flash).
const KEY = 'eili_auth_kind'; // 'user' | 'guest'

export const getAuthKind = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

const setAuthKind = (kind) => {
  try {
    if (kind) localStorage.setItem(KEY, kind);
    else localStorage.removeItem(KEY);
  } catch { /* private mode */ }
};

export const isRegisteredUser = () => getAuthKind() === 'user';

let installed = false;

// Keeps the flag in sync with every /auth/me, /auth/login and /auth/logout call.
export function installAuthStateInterceptor() {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    if (/\/api\/auth\/logout$/.test(config.url || '')) setAuthKind(null);
    return config;
  });
  axios.interceptors.response.use(
    (res) => {
      const url = res.config?.url || '';
      if (/\/api\/auth\/me$/.test(url) && res.data?.user_id) {
        setAuthKind(res.data.is_guest ? 'guest' : 'user');
      } else if (/\/api\/auth\/guest$/.test(url)) {
        setAuthKind('guest');
      } else if (/\/api\/auth\/login$/.test(url) && !res.data?.requires_2fa) {
        setAuthKind('user');
      }
      return res;
    },
    (error) => {
      const url = error.config?.url || '';
      if (/\/api\/auth\/me$/.test(url) && error.response?.status === 401) setAuthKind(null);
      return Promise.reject(error);
    },
  );
}
